// extracted by mini-css-extract-plugin
export default {"messages":"aW2iZyj9MLMAI6PQC_Ss","singleMessageContainer":"smN9Iz64vUeEWhz_1kZO"};